import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { Label } from 'reactstrap';
type Props = {
  usersList: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    telegram: string | null;
  }[];
  setSearch?: (value: string) => void;
  userFilter?: string;
  defaultValue?: { label: string; value: string } | null;
  onClear?: () => void;
};

export const ScoringUserFilter = ({
  usersList,
  setSearch,
  userFilter,
  defaultValue,
  onClear,
}: Props) => {
  const { t } = useTranslation();

  const conditions = usersList?.map((user) => ({
    value: user.email,
    label: `${user.firstName} ${user.lastName}`,
  }));

  const selectedOption = userFilter
    ? (conditions?.find((c) => c.value === userFilter) ?? null)
    : (defaultValue ?? null);
  return (
    <div className="mb-3 d-flex align-items-center gap-2" style={{ maxWidth: '400px' }}>
      <Label>{t('scoring.totalTable.user')}:</Label>
      <Select<{ value: string; label: string }, false>
        options={conditions}
        closeMenuOnSelect={true}
        className="custom-selector scoring-user-filter no_placeholder"
        classNamePrefix={'custom-selector scoring-user-filter'}
        isClearable={true}
        // defaultInputValue={defaultValue ? defaultValue.label : t('global.selector.allUsers')}
        defaultValue={defaultValue}
        // styles={colourStyles}
        formatOptionLabel={(option: any) => <span>{option.label}</span>}
        value={selectedOption}
        onChange={(selected) => {
          const value = selected ? (selected as any).value : '';
          setSearch && setSearch(value);
          if (!selected) {
            // clear handler for parent to reset userFilter/defaultValue
            onClear && onClear();
          }
        }}
        placeholder={t('global.selector.allUsers')}
      />
    </div>
  );
};
